/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Coinvestments_Tracking_Stage_Placeholder1Inputs */

const en_coinvestments_tracking_stage_placeholder1 = /** @type {(inputs: Coinvestments_Tracking_Stage_Placeholder1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stage: ${i?.value}`)
};

/**
* | output |
* | --- |
* | "Stage: {value}" |
*
* @param {Coinvestments_Tracking_Stage_Placeholder1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_stage_placeholder1 = /** @type {((inputs: Coinvestments_Tracking_Stage_Placeholder1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Stage_Placeholder1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_stage_placeholder1(inputs)
});
export { coinvestments_tracking_stage_placeholder1 as "coInvestments_tracking_stage_placeholder" }